import Vue from 'vue';
import _ from 'lodash-extended';
import app from 'app';

/**
 * Bind event name to component method with the same name
 *
 * @usage
 * when needed:
 * storyViewBus.mind(this, ['event', ...]);
 *
 * in beforeDestroy:
 * storyViewBus.neverMind(this);
 */
export default new Vue({
  methods: {
    mind(component, events) {
      component.$options.__svbOffListeners = [];
      _.each(events, (event) => {
        const method = component[event];
        if (method) {
          this.$on(event, method);
          component.$options.__svbOffListeners.push(() => {
            this.$off(event, method);
          });
        } else {
          app.doctorController.report(
            `storyViewBus::mind -> method expected "${event}"`
          );
        }
      });
    },

    neverMind(component) {
      _.each(component.$options.__svbOffListeners, (off) => off());
    },
  },
});
